//Products
export const PRODUCTS_LIST = 'products';
export const PRODUCTS_STORE = 'products';

//Categories
export const CATEGORY_LIST = 'categories';

//Taxes
export const TAX_LIST = 'taxes';

//Client
export const CLIENT_LIST = 'clients';

// Invoice
export const INVOICES = 'invoices';
export const INVOICES_SEND = 'invoice-send';

//Payment History
export const PAYMENTHISTORY = 'payment-histories';